<template>
  <div class="cards__container">
    <div class="cards__single gray">
      <p class="cards__title">
        Registration
      </p>
      <div class="cards__description">
        <p>8:00 AM - 2:00 PM</p>
      </div>
      <div class="cards__location">
        @ Patio del Fauno Lobby
      </div>
    </div>
    <div class="cards__single grayblue">
      <p class="cards__title">
        Breakfast
      </p>
      <div class="cards__description">
        <p>8:00 AM - 10:00 AM</p>
      </div>
      <div class="cards__location">
        @ Patio del Fauno Lobby
      </div>
    </div>
    <div class="cards__single purple noheight">
      <p class="cards__title">
        1:1 Meetings
      </p>
      <div class="cards__description">
        <p>10:00 AM - 4:00 PM</p>
      </div>
      <div class="cards__location">
        @ Salon Dorado
      </div>
    </div>
    <div v-for="(speaker, index) in speakers" :key="index" class="cards__single cerulean" :class="speaker.class">
      <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
      <div v-if="speaker.imgClass" class="circle"></div>
      <div class="cards__speaker">
        <p class="cards__name">{{ speaker.name }}</p>
        <p class="cards__spktitle spkposition" v-html="speaker.position"></p>
        <p class="cards__spktitle" v-html="speaker.title"></p>
      </div>
      <div class="cards__description">
        <p class="time">{{ speaker.time }}</p>
        <p class="location">{{ speaker.location }}</p>
      </div>
    </div>
  </div>
  <div class="morning">
    <h2 class="subtitle">
      Morning Sessions
    </h2>
    <div v-if="isMobile" class="mobile slider">
      <carousel>
        <slide :key="1">
          <div class="grid__tracks">
            <div class="--title">
              Track 1 (Fauno West)
            </div>
            <div class="--slot t1" v-for="info in track1" :key="info.company" @click="openModal(info.company)">
              <div class="--slot__time">
                <p>{{ info.start }}</p>
                <p>{{ info.end }}</p>
              </div>
              <p class="--slot__title">
                {{ info.company }}
              </p>
            </div>
          </div>
        </slide>
        <slide :key="2">
          <div class="grid__tracks">
            <div class="--title">
              Track 2 (Patio del Fauno)
            </div>
            <div class="--slot t2" v-for="info in track2" :key="info.company" @click="openModal(info.company)">
              <div class="--slot__time">
                <p>{{ info.start }}</p>
                <p>{{ info.end }}</p>
              </div>
              <p class="--slot__title">
                {{ info.company }}
              </p>
            </div>
          </div>
        </slide>
        <template #addons>
          <navigation />
        </template>
      </carousel>
    </div>
    <div v-else>
      <div class="grid__container two-column">
        <div class="grid__tracks">
          <div class="--title">
            Track 1 (Fauno West)
          </div>
          <div class="--slot t1 clickable" v-for="info in track1" :key="info.company" @click="openModal(info.company)">
            <div class="--slot__time">
              <p>{{ info.start }}</p>
              <p>{{ info.end }}</p>
            </div>
            <p class="--slot__title">
              {{ info.company }}
            </p>
          </div>
        </div>
        <div class="grid__tracks">
          <div class="--title">
            Track 2 (Patio del Fauno)
          </div>
          <div class="--slot t2 clickable" v-for="info in track2" :key="info.company" @click="openModal(info.company)">
            <div class="--slot__time">
              <p>{{ info.start }}</p>
              <p>{{ info.end }}</p>
            </div>
            <p class="--slot__title">
              {{ info.company }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div :class="{ 'modal-show': isModalOpen }" v-if="isModalOpen" class="modal" @click="handleModalBackdropClick">
    <div class="modal-content" @click.stop>
      <span class="close" @click="closeModal">&times;</span>
      <div v-if="errorMessage">
        <h1 class="title">Error</h1>
        <p class="description">{{ errorMessage }}</p>
      </div>
      <div v-else>
        <h1 class="speaker">{{ activeCardInfo?.speaker || activeCompanyInfo?.company }}</h1>
        <h2 v-if="activeCardInfo" class="title">{{ activeCardInfo.title }}</h2>
        <p class="description" v-if="activeCardInfo" v-html="activeCardInfo.description"></p>
        <p class="description" v-if="activeCompanyInfo">{{ activeCompanyInfo.description }}</p>
        <a
          v-if="activeCompanyInfo?.url"
          :href="activeCompanyInfo.url"
          target="_blank"
          class="btn-new-alt"
        >
          Visit Website
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'

export default {
  name: 'Day Two Morning',
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      track1: [
        { start: '10:30 AM', end: '11:00 AM', company: 'Jaguar Health Inc.', hr: '10:00', duration: 29 },
        { start: '11:00 AM', end: '11:30 AM', company: 'Ederra', hr: '10:30', duration: 29 },
        { start: '11:30 AM', end: '12:00 PM', company: 'The Manifest Network', hr: '11:00', duration: 29 }
      ],
      track2: [
        { start: '10:30 AM', end: '11:00 AM', company: 'Keynote: Xaviaer DuRousseau', hr: '10:00', duration: 29 },
        { start: '11:00 AM', end: '11:30 AM', company: 'Keynote: George Azih', hr: '10:30', duration: 29 },
        { start: '11:30 AM', end: '12:00 PM', company: 'Wellgistics Health', hr: '11:00', duration: 29 },
        { start: '12:30 PM', end: '1:00 PM', company: 'Akupara Adventures', hr: '12:30', duration: 29 }
      ],
      companyData: {
        'Jaguar Health Inc.': {
          description: 'Jaguar Health, Inc. is a commercial-stage biotechnology company focused on developing and commercializing plant-based prescription medicines for gastrointestinal conditions in humans and animals, anchored by its FDA-approved product Mytesi®, derived from a sustainably sourced Amazonian botanical. Headquartered in San Francisco, the company operates through subsidiaries including Napo Pharmaceuticals and Napo Therapeutics, advancing a pipeline that targets unmet needs in supportive care while emphasizing environmental sustainability and ethical sourcing.',
          url: 'https://jaguarhealth.gcs-web.com/'
        },
        'The Manifest Network': {
          description: 'We empower taking control of your cloud data and building Sovereign Protocols.',
          url: 'https://manifest.network/'
        },
        'Ederra': {
          description: 'Ederra is a wellness company dedicated to empowering individuals to take control of their health through natural, nutrient-rich supplements. Their flagship product, EMPWR+, combines broccoli microgreens and Lion\'s Mane mushrooms to enhance cognitive function, provide antioxidant protection, and promote overall well-being.',
          url: 'https://ederralyfe.com/'
        },
        'Wellgistics Health': {
          description: 'Our solutions provide a seamless prescription ecosystem through an integrated technology platform, wholesale distribution, and fulfillment network focused on Independent Pharmacies and Specialty Lite medications.',
          url: 'https://wellgisticshealth.com/'
        },
        'Akupara Adventures': {
          description: "Akupara will be the world's premier chain of eco-adventure parks.  Inspired by nature, and the human spirit, it will invite visitors to explore the awe and magic of the world around them.",
          url: 'https://www.akuparaadventures.com/'
        }
      },
      speakers: [
        {
          imgClass: 'miglino',
          name: 'Chris Miglino',
          title: '"Welcome to Day 2 Keynote"',
          position: 'President - DNA',
          time: '9:30 AM - 10:00 AM',
          location: 'Patio del Fauno'
        },
        {
          imgClass: 'carson',
          name: 'Greg Carson',
          title: '"The Financial Ecosystem transformation with Bitcoin and Stablecoins"',
          position: 'Managing Partner - Humla Ventures',
          time: '10:00 AM - 10:30 AM',
          location: 'Patio del Fauno'
        },
        {
          imgClass: 'xaviaer',
          name: 'Xaviaer DuRousseau',
          position: 'PragerU Media Personality',
          time: '10:30 AM - 11:00 AM',
          location: 'Patio del Fauno'
        },
        {
          imgClass: 'azih',
          name: 'George Azih',
          position: 'Founder - FinQuery',
          time: '11:00 AM - 11:30 AM',
          location: 'Patio del Fauno'
        }
      ],
      cardData: {
      },
      activeCardInfo: null,
      errorMessage: null,
      isModalOpen: false,
      isMobile: false,
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 768;
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleEscKey);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    handleEscKey(event) {
      if (event.key === 'Escape' && this.isModalOpen) {
        this.closeModal();
      }
    },
    handleModalBackdropClick(event) {
      if (event.target.classList.contains('modal')) {
        this.closeModal();
      }
    },
    openModal(identifier) {
      if (this.cardData[identifier]) {
        this.activeCardInfo = this.cardData[identifier];
        this.activeCompanyInfo = null;
        this.errorMessage = null;
        this.isModalOpen = true;
      } else if (this.companyData[identifier]) {
        this.activeCompanyInfo = {
          ...this.companyData[identifier],
          company: identifier,
        };
        this.activeCardInfo = null;
        this.errorMessage = null;
        this.isModalOpen = true;
      } else {
        console.error(`Currently no info has been found for "${identifier}".`);
        this.activeCardInfo = null;
        this.activeCompanyInfo = null;
        this.errorMessage = null;
        this.isModalOpen = false;
      }
    },
    closeModal() {
      this.isModalOpen = false;
      this.activeCardInfo = null;
      this.activeCompanyInfo = null;
      this.errorMessage = null;
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keydown', this.handleEscKey);
  },
};
</script>
